import React from "react";
import { FaHeart } from "react-icons/fa";

/**
 * Placeholder "Leave a tip" button in the sidebar.
 *
 * v1 scope is fixed-amount links only — tips would require the
 * backend to accept a variable amount on the x402 request, which
 * the facilitator doesn't support for the "exact" scheme. Rendered
 * as a no-op with a toast-like hint so the UI matches the mockup
 * without shipping half-working functionality.
 *
 * TODO (P5): hook up when variable-amount links land.
 */
export function TipButton() {
  return (
    <button
      className="pay-tip"
      onClick={() => {
        /* No-op v1 — variable amounts land in P5. */
      }}
      disabled
      title="Tipping is coming soon — v1 supports fixed amounts only."
    >
      <FaHeart size={12} /> Leave a tip (coming soon)
    </button>
  );
}
